module.exports = require('./endpoints.js')
